import { memo, Suspense } from 'react';
import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import useWindowSize from '../../hooks/useWindowSize';
import BlockedLayoutSideMenu from './BlockedLayoutSideMenu';

const BlockedLayout = ({ children, Top, fullPage }) => {
  const { isMobile } = useWindowSize();

  return (
    <Layout
      className={`blank_layout_wrapper ${
        Top ? 'padding_top_30' : 'remove_padding'
      }`}
    >
      <BlockedLayoutSideMenu />
      <Layout className="blocked_layout_content_wrapper">
        <Content
          className={`main_content padding_10 ${
            fullPage || isMobile ? 'full_width' : 'width_700px'
          }`}
        >
          <Suspense fallback={null}>{children}</Suspense>
        </Content>
      </Layout>
    </Layout>
  );
};

export default memo(BlockedLayout);
